"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddPersonalNutritionItemsErrorResponse = exports.Name = exports.AddPersonalNutritionItemsFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'add-personal-nutrition-items-failed';
const AddPersonalNutritionItemsFailedEvent = exports.AddPersonalNutritionItemsFailedEvent = Name;
const isAddPersonalNutritionItemsErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isAddPersonalNutritionItemsErrorResponse = isAddPersonalNutritionItemsErrorResponse;
